import { useQuery } from '@tanstack/react-query';
import QueryKeys from '../utils/QueryKeys';
import { Package, Price } from '../models';

export default function usePastImagesQuickOrderPricelist(schoolId) {
  return useQuery({
    queryKey: [QueryKeys.pastImagesQuickOrder, QueryKeys.pricelist, schoolId],
    queryFn: () => (
      Package
        .selectExtra(['defaultBackgroundUrl'])
        .includes({
          backgroundSet: 'backgrounds',
          options: ['image_types', 'prices'],
          package_poses: 'background',
        })
        .merge({ prices: Price.where({ for_school: schoolId }) })
        // ONE filter, not pastImagesQuickOrder + schoolId: the server decides whether
        // this school has its own linked pricelist or falls back to the default.
        // Requiring a school_packages link left the Quick Order screen unreachable
        // for all but 248 of ~10,500 elementary/middle/high schools.
        .where({ pastImagesQuickOrderForSchool: schoolId })
        .all()
        .then((res) => (res.data && res.data[0]) || null)
    ),
    placeholderData: null,
    staleTime: 60_000,
    enabled: !!schoolId,
  });
}
